import { MouseEventHandler } from 'react';
import { sprintf } from 'sprintf-js';

import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { TileGridVariant } from 'components/TileGrid/TileGridVariant';
import { useTabContext } from 'containers/TabContext';

import {
  TileGridBlockTileButton,
  TileGridBlockTileHeading,
  TileGridBlockTileImageHolder,
  TileGridBlockTileSubHeading,
} from './TileGridTile.styled';
import { tileGridTilePropsByVariant } from './tileGridTilePropsByVariant';

type Props = {
  id: string;
  imageData: ApiFilestackImageData;
  variant: TileGridVariant;
  heading: string;
  subHeading: string | null;
  onClick: MouseEventHandler;
};

export function TileGridTile({
  id,
  imageData,
  variant,
  heading,
  subHeading,
  onClick,
}: Props) {
  const alt = sprintf(getText('Image of %(heading)s'), { heading });

  const { width, height, borderRadius, qaId, marginBottom, noCrop } =
    tileGridTilePropsByVariant[variant];

  const oneByOneRatio = width === height;
  const isTabbing = useTabContext();

  return (
    <TileGridBlockTileButton id={id} $isTabbing={isTabbing} onClick={onClick}>
      <TileGridBlockTileImageHolder
        style={{
          marginBottom,
          aspectRatio: oneByOneRatio ? '1' : undefined,
          borderRadius,
          width,
          height: oneByOneRatio ? undefined : height,
        }}
      >
        <FilestackImage
          data={imageData}
          data-qa-id={qaId}
          alt={alt}
          noCrop={noCrop}
          width={width}
          height={height}
          objectFit="cover"
        />
      </TileGridBlockTileImageHolder>

      <TileGridBlockTileHeading>{heading}</TileGridBlockTileHeading>

      {subHeading && (
        <TileGridBlockTileSubHeading>{subHeading}</TileGridBlockTileSubHeading>
      )}
    </TileGridBlockTileButton>
  );
}
